import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';

import {
  GenreSimplifieRequestDtoFormatsPlaquesEnum,
  GenreSimplifieViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen/api';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { FormInputProps } from 'components/BaseForm/types';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import { GenreSimplifieFormField, GenreSimplifieFormValue } from '../types';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: GenreSimplifieFormValue;
  title: string;
  submit: (values: GenreSimplifieFormValue) => void;
  isSubmitting: boolean;
  validate: (
    field: GenreSimplifieFormField,
    values: GenreSimplifieFormValue,
  ) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<
    FormInputProps<GenreSimplifieFormValue, GenreSimplifieFormField>
  > = [
    {
      name: 'libelle',
      label: 'Libellé',
      field: GenreSimplifieViolationDtoFormFieldEnum.LIBELLE,
      required: true,
    },
    {
      name: 'dicem',
      label: 'Motif DICEM',
      valuePropName: 'checked',
      render: () => <AntdCheckbox />,
      field: GenreSimplifieViolationDtoFormFieldEnum.DICEM,
    },
    {
      name: 'formatsPlaque',
      label: 'Formats plaque',
      field: GenreSimplifieViolationDtoFormFieldEnum.FORMATS_PLAQUES,
      render: () => {
        return (
          <BaseSelect
            mode="multiple"
            options={Object.keys(GenreSimplifieRequestDtoFormatsPlaquesEnum)}
            getOptionValue={option => option}
            getOptionLabel={option => option}
          />
        );
      },
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
